import React, { useState, useEffect } from 'react';

import * as Util from '../data/General';
import ChartRequest from '../components/widget/ChartRequest';
import Filter from '../components/widget/Filter';
import mixpanel from 'mixpanel-browser';


function Spreadsheet(props) {
  const { setCSV } = props;
  const [file, setFile] = useState();
  const [array, setArray] = useState([]);
  const [errors, setErrors] = useState([]);
  const [isOk, setIsOk] = useState(false);

  const [droppedFiles, setDroppedFiles] = useState(false);

  const validate = ["number", "string","string", "string"];

  const fileReader = new FileReader();
  let $form = null;

  

  const handleOnChange = (e, isFile=false, file=null) => {
    let fil = !isFile ? e.target.files[0] : file;
    setFile(fil);
    let fi = fil;
    if (fi) {
      fileReader.onload = function (event) {
        const text = event.target.result;
        csvFileToArray(text, fil);
      };

      fileReader.readAsText(fi);
    }
  };

  const csvFileToArray = (string, fil) => {
    let ext = fil.name.split(".").pop();
    if(ext !== "csv"){
      let errors = [];
      errors.push("error_spreadsheet_0");
      setErrors(errors);
      return;
    }

    const csvHeader = string.slice(0, string.indexOf("\n")).split(",");
    const csvRows = string.slice(string.indexOf("\n") + 1).split("\n");
    let errors = [];
    let count = 0;
    let array = csvRows.map(i => {
      const values = i.split(",");
      let isEmpty = true;
      const obj = csvHeader.reduce((object, header, index) => {
        object[header] = values[index];
        if(index <= validate.length){
          
        
          if((validate[index] === "number" && (values[index] === "" || (/\D/.test(values[index])))) 
            || (validate[index] === "string" && values[index] === "")){
            errors[count]="error_spreadsheet_"+(index+1);
          }
        }
        count++;
        if(index < 2 && values[index]){
          isEmpty = false;
        }
        return object;
      }, {});

      if(!isEmpty){
        return obj;
      }
    });
    array = array.filter(Boolean);
    console.log("array", array);
    setArray(array);
    setErrors(errors);

    if(errors.length === 0 && array.length > 0){
      setIsOk(true);
      console.log("file", fil);
      setCSV(fil, array.length);
    }
  };

  const handleOnSubmit = () => {
    //e.preventDefault();

    
  };

  const handleOnDragOver = (e, add, del) => {
    e.preventDefault();
    e.stopPropagation();
    if(add !== ""){
      $form.classList.add(add);
    }
    if(del !== ""){
      $form.classList.remove(del);
    }
  };

  useEffect(() => {
    $form = document.getElementById("form");
    if($form){
      $form.addEventListener('dragenter', function(e) {
        handleOnDragOver(e,'is-dragover', "");
      });
      $form.addEventListener('dragover', function(e) {
        handleOnDragOver(e,'is-dragover', "");
      });
      $form.addEventListener('dragleave', function(e) {
        handleOnDragOver(e,'', "is-dragover");
      });
      $form.addEventListener('dragend', function(e) {
        handleOnDragOver(e,'', "is-dragover");
      });
      $form.addEventListener('drop', function(e) {
        
        setDroppedFiles(e.dataTransfer.files);
        //let $csvFileInput = document.getElementById("csvFileInput");
        //$csvFileInput.files = e.dataTransfer.files;
        console.log("e.dataTransfer.files[0]", e.dataTransfer.files[0]);
        handleOnChange(e, true, e.dataTransfer.files[0]);
        console.log("e", e);
        handleOnDragOver(e,'', "is-dragover");
      });
    }
  },[]);

  //const headerKeys = Object.keys(Object.assign({}, ...array));

  return (
    <div>
      {!isOk ? (
        <form id="form">
          <input
            type={"file"}
            id={"csvFileInput"}
            name="csvFileInput"
            accept={".csv"}
            onChange={handleOnChange}
            style={{display:"none"}}
          />
          <label htmlFor="csvFileInput" className='label-file'>
              <div>
                <span className="formbold-drop-file"> {Util.getMessage("DropFile")}</span>
                <span className="formbold-or"> O </span>
                <span className="formbold-browse"> {Util.getMessage("SelectFile")} </span>
              </div>
            </label>

          {/*<button
            onClick={(e) => {
              handleOnSubmit(e);
            }}
          >
            IMPORT CSV
          </button>*/}
        </form>
      ) : (
        <>
          <p>{Util.getMessage("CantFile")}: {array.length}</p>
          <label style={{fontSize: "13px"}}><small>{Util.getMessage("confirm_campaign_7")}</small></label>
        </>
      )}

      {errors.length > 0 ? (     
      <div className='errors-spread'>
        <h3>{Util.getMessage("Errors")}</h3>
        {errors.map((val, index) => (
            <p key={index}>{Util.getMessage(val)}</p>
          ))}
      </div>
      ) : null }
      <div className='linkstemplate '>
        <a href="https://help.revie.ai/es/article/como-seleccionar-la-audiencia-de-tu-campana-1n88rfy/" target='_blank' >{Util.getMessage("spreadsheet_help")}</a>
        <a href="/data/template_campaign.csv" target='_blank' >{Util.getMessage("spreadsheet_example")}</a>
      </div>
    </div>
        
  );
}

export default Spreadsheet;